import { FileText, Link, Video } from "lucide-react";

const ICONS = {
	doc: FileText,
	link: Link,
	video: Video,
} as const;

export function SidebarItem({
	icon,
	title,
	active,
}: {
	icon: "doc" | "link" | "video";
	title: string;
	active?: boolean;
}) {
	const Icon = ICONS[icon];
	return (
		<a
			className={`flex items-center gap-2 px-4 py-1.5 text-[11px] ${
				active
					? "border-cv-accent text-cv-fg border-l-2 bg-white/5"
					: "text-cv-fg-sec"
			}`}
		>
			<Icon
				className={`h-3.5 w-3.5 shrink-0 ${active ? "text-cv-fg-sec" : "text-cv-fg-muted"}`}
				strokeWidth={1.5}
			/>
			<span className="truncate">{title}</span>
		</a>
	);
}
